import {
  ICategory,
  ISubcategory,
  IItem,
  IExistenceOld,
  IDealer,
  IClient,
  IStore,
  IRetirement,
  IBank,
  ICurrency,
  IPaymentMethod,
  IBankAccountOld,
  Credentials,
  IClientResponse,
  IDealerResponse,
  IWarehouse,
  INewAssociatedCode,
  IDeleteAssociatedCode,
  IDeleteCompound,
  INewCompound,
  ISetCompound,
  IEditCompound,
  IUnit,
  ICostAndPrice,
  IRotation,
  IItemPayload,
  ITransferOld,
  IExistencesInWarehouse,
  IExistenceUpdateWarehouse,
  IMovements,
  States,
  IMoneyAccount,
  ITransactions,
  ISeller,
  IDeliveryNotesBySellerAndClient,
} from 'safe'
import { TypeOfTag } from 'typescript'

//Authentication
export const AUTH_USER_LOGIN = 'AUTH_USER_LOGIN'
export const AUTH_USER_LOGOUT = 'AUTH_USER_LOGOUT'
export const AUTH_USER_SIGNUP = 'AUTH_USER_SIGNUP'
export const AUTH_USER_FIRSTSIGNUP = 'AUTH_USER_FIRSTSIGNUP'
export const AUTH_USER_SECONDSIGNUP = 'AUTH_USER_SECONDSIGNUP'
export const AUTH_USER_THIRDSIGNUP = 'AUTH_USER_THIRDSIGNUP'
export const AUTH_USER_FOURTHSIGNUP = 'AUTH_USER_FOURTHSIGNUP'
export const CHANGE_FIRST_TIME = 'CHANGE_FIRST_TIME'


interface authUserLoginAction {
  type: typeof AUTH_USER_LOGIN
  payload: {
    user: any
  }
}

interface authUserLogOut {
  type: typeof AUTH_USER_LOGOUT
}

interface authUserSignUp {
  type: typeof AUTH_USER_SIGNUP
  payload: any
}

interface authUserFirstSignUp {
  type: typeof AUTH_USER_FIRSTSIGNUP
  payload: {email: string; password: string}
}

interface authUserSecondSignUp {
  type: typeof AUTH_USER_SECONDSIGNUP
  payload: {
    name: string
    phone: string
    // businessName: string
    // country: string
    // postalCode: string
  }
}

interface authUserThirdSignUp {
  type: typeof AUTH_USER_THIRDSIGNUP
  payload: {
    businessName: string
    businessSocial: string
    document: {
      document: string
      documentType: string
    }
    address: string
    country: string
    state: string
    city: string
    postalCode: string
  }
}

interface authUserFourthSignUp {
  type: typeof AUTH_USER_FOURTHSIGNUP
  payload: {
    image: any
  }
}

interface changeFirstTime {
  type: typeof CHANGE_FIRST_TIME,
  payload: any
}

//Categories
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const CREATE_CATEGORY = 'CREATE_CATEGORY'
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'

export const CREATE_SUBCATEGORY = 'CREATE_SUBCATEGORY'
export const UPDATE_SUBCATEGORY = 'UPDATE_SUBCATEGORY'
export const DELETE_SUBCATEGORY = 'DELETE_SUBCATEGORY'

interface setCategoriesAction {
  type: typeof SET_CATEGORIES
  payload: ICategory[]
}

interface createCategoryAction {
  type: typeof CREATE_CATEGORY
  payload: ICategory
}

interface updateCategoryAction {
  type: typeof UPDATE_CATEGORY
  payload: {
    id: string
    name: string
    code: string
    description: string
  }
}

interface deleteCategoryAction {
  type: typeof DELETE_CATEGORY
  payload: string
}

interface createSubcategoryAction {
  type: typeof CREATE_SUBCATEGORY
  payload: ISubcategory
}

interface updateSubcategoryAction {
  type: typeof UPDATE_SUBCATEGORY
  payload: ISubcategory
}

interface deleteSubcategoryAction {
  type: typeof DELETE_SUBCATEGORY
  payload: ISubcategory
}

//Items
export const SET_ITEMS = 'SET_ITEMS'
export const SET_ITEM = 'SET_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const DELETE_ITEM = 'DELETE_ITEM'
export const EDIT_CATALOG_STATUS = 'EDIT_CATALOG_STATUS'

export const SET_ITEM_LIST = 'SET_ITEM_LIST'

//Associated Code
export const SET_ASSOCIATED_CODE = 'SET_ASSOCIATED_CODE'
export const DELETE_ASSOCIATED_CODE = 'DELETE_ASSOCIATED_CODE'

//Compound
export const DELETE_COMPOUND_CODE = 'DELETE_COMPOUND_CODE'
export const SET_COMPOUND = 'SET_COMPOUND'
export const EDIT_COMPOUND = 'EDIT_COMPOUND'

//Assembly
export const DELETE_ASSEMBLY = 'DELETE_ASSEMBLY'
export const SET_ASSEMBLY = 'SET_ASSEMBLY'
export const EDIT_ASSEMBLY = 'EDIT_ASSEMBLY'

//Unit
export const GET_UNIT = 'GET_UNIT'
export const ADD_COST_AND_PRICE = 'ADD_COST_AND_PRICE'

export const UPDATE_ROTATION = 'UPDATE_ROTATION'

interface setItemsAction {
  type: typeof SET_ITEMS
  payload: IItemPayload
}

interface setItemAction {
  type: typeof SET_ITEM
  payload: IItem
}

interface updateItemAction {
  type: typeof UPDATE_ITEM
  payload: IItem
}

interface deleteItem {
  type: typeof DELETE_ITEM
  payload: { itemId: string }
}

interface editCatalogStatus {
  type: typeof EDIT_CATALOG_STATUS,
  payload: any
}

interface setItemList {
  type: typeof SET_ITEM_LIST
  payload: any
}

interface setAssociatedCode {
  type: typeof SET_ASSOCIATED_CODE
  payload: INewAssociatedCode
}

interface deleteAssociatedCode {
  type: typeof DELETE_ASSOCIATED_CODE
  payload: IDeleteAssociatedCode
}

interface deleteCompound {
  type: typeof DELETE_COMPOUND_CODE
  payload: IDeleteCompound
}
interface setCompound {
  type: typeof SET_COMPOUND
  payload: ISetCompound
}

interface editCompound {
  type: typeof EDIT_COMPOUND
  payload: IEditCompound
}

interface deleteAssembly {
  type: typeof DELETE_ASSEMBLY
  payload: any
}

interface setAssembly {
  type: typeof SET_ASSEMBLY
  payload: ISetCompound
}

interface editAssembly {
  type: typeof EDIT_ASSEMBLY
  payload: any
}

interface getUnits {
  type: typeof GET_UNIT
  payload: IUnit[]
}

interface addCostAndPrice {
  type: typeof ADD_COST_AND_PRICE
  payload: ICostAndPrice
}

interface updateRotation {
  type: typeof UPDATE_ROTATION
  payload: IRotation
}

//Locations
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_LOCATION = 'SET_LOCATION'
export const UPDATE_LOCATION = 'UPDATE_LOCATION'
export const DELETE_LOCATION = 'DELETE_LOCATION'

interface setLocationAction {
  type: typeof SET_LOCATION
  payload: IStore
}

interface setLocationsAction {
  type: typeof SET_LOCATIONS
  payload: IStore[]
}

interface updateLocationAction {
  type: typeof UPDATE_LOCATION
  payload: IStore
}

interface deleteLocationAction {
  type: typeof DELETE_LOCATION
  payload: IStore
}

//Warehouses
export const SET_WAREHOUSES = 'SET_WAREHOUSES'
export const SET_WAREHOUSE = 'SET_WAREHOUSE'
export const UPDATE_WAREHOUSE = 'UPDATE_WAREHOUSE'
export const DELETE_WAREHOUSE = 'DELETE_WAREHOUSE'
export const UPDATE_WAREHOUSE_EXISTENCE = 'UPDATE_WAREHOUSE_EXISTENCE'

//Refund
export const UPDATE_SALE = 'UPDATE_SALE'

interface setWarehouseAction {
  type: typeof SET_WAREHOUSE
  payload: IWarehouse
}

interface setWarehousesAction {
  type: typeof SET_WAREHOUSES
  payload: IWarehouse[]
}

interface updateWarehouseAction {
  type: typeof UPDATE_WAREHOUSE
  payload: IWarehouse
}

interface deleteWarehouseAction {
  type: typeof DELETE_WAREHOUSE
  payload: IWarehouse
}

interface updateWarehouseExistence {
  type: typeof UPDATE_WAREHOUSE_EXISTENCE
  payload: IExistenceUpdateWarehouse
}

//Existences
export const SET_EXISTENCES = 'SET_EXISTENCES'
export const SET_EXISTENCE = 'SET_EXISTENCE'
export const UPDATE_EXISTENCE = 'UPDATE_EXISTENCE'
export const CLEAN_ITEMS = 'CLEAN_ITEMS'

//DeliveryNotes
export const SET_DELIVERY_NOTES = 'SET_DELIVERY_NOTES'
export const CLEAN_DELIVERY_NOTES = 'CLEAN_DELIVERY_NOTES'

//Purchases
export const SET_PURCHASES = 'SET_PURCHASES'
export const CLEAN_PURCHASES = 'CLEAN_PURCHASES'

//PurchaseOrders
export const SET_PURCHASE_ORDERS = 'SET_PURCHASE_ORDERS'
export const CLEAN_PURCHASE_ORDERS = 'CLEAN_PURCHASE_ORDERS'

// Sells
export const SET_SELLS = 'SET_SELLS'
export const CLEAN_SELLS = 'CLEAN_SELLS'

//Sellers
export const SET_SELLERS = 'SET_SELLERS'

// Pending Sells
export const SET_PENDING_SELLS = 'SET_PENDING_SELLS'
export const CLEAN_PENDING_SELLS = 'CLEAN_PENDING_SELLS'
export const DELETE_MULTIPLE_PENDING_SELLS = 'DELETE_MULTIPLE_PENDING_SELLS'

//Movements
export const SET_MOVEMENTS = 'SET_MOVEMENTS'

//Sales delivery Notes
export const SET_SALE_PENDING_DELIVERY_NOTES = 'SET_SALE_PENDING_DELIVERY_NOTES'
export const SET_HISTORIC_DELIVERY_NOTES = 'SET_HISTORIC_DELIVERY_NOTES'
export const DELETE_MULTIPLE_DELIVERY_NOTES = 'DELETE_MULTIPLE_DELIVERY_NOTES'

interface setExistenceActionOld {
  type: typeof SET_EXISTENCE
  payload: {
    id: number
    type: 'store' | 'warehouse'
    existence: IExistenceOld
  }
}

interface setExistenceAction {
  type: typeof SET_EXISTENCE
  payload: IExistencesInWarehouse
}

interface cleanItemsAction {
  type: typeof CLEAN_ITEMS
}

interface setDeliveryNotes {
  type: typeof SET_DELIVERY_NOTES
  payload: States.DeliveryNotes
}

interface cleanDeliveryNotes {
  type: typeof CLEAN_DELIVERY_NOTES
}

interface setSalePendingDeliveryNotes {
  type: typeof SET_SALE_PENDING_DELIVERY_NOTES
  payload: any
}

interface setHistoricDeliveryNotes {
  type: typeof SET_HISTORIC_DELIVERY_NOTES
  payload: any
}

interface deleteMultipleSaleDeliveryNotes {
  type: typeof DELETE_MULTIPLE_DELIVERY_NOTES
  payload: any
}

interface setPurchases {
  type: typeof SET_PURCHASES
  payload: States.Purchases
}

interface cleanPurchases {
  type: typeof CLEAN_PURCHASES
}

interface setPurchaseOrders {
  type: typeof SET_PURCHASE_ORDERS
  payload: States.PurchaseOrders
}

interface cleanPurchaseOrders {
  type: typeof CLEAN_PURCHASE_ORDERS
}

interface setSellsAction {
  type: typeof SET_SELLS
  payload: States.Sells
}

interface cleanSellsAction {
  type: typeof CLEAN_SELLS
}

interface updateSells {
  type: typeof UPDATE_SALE
  payload: string
}

interface setSellersAction {
  type: typeof SET_SELLERS
  payload: {
    sellers: ISeller[]
    numberOfPages: number
  }
}

interface setClientsBySeller {
  type: typeof GET_CLIENTS_BY_SELLERS
  payload: {
    clientsSeller: any[]
    numberOfPages: number
  }
}

interface enableSeller {
  type: typeof ENABLE_SELLER
  payload: {
    id
    enable
  }
}

interface setDeliveryNotesByClient {
  type: typeof GET_DELIVERY_NOTES_BY_CLIENT
  payload: {
    deliveryNotesByClient: IDeliveryNotesBySellerAndClient[]
    numberOfPages: number
  }
}

interface setPendingSellsAction {
  type: typeof SET_PENDING_SELLS
  payload: States.PendingSells
}

interface cleanPendingSellsAction {
  type: typeof CLEAN_PENDING_SELLS
}

interface deleteMultipleSells {
  type: typeof DELETE_MULTIPLE_PENDING_SELLS
  payload: string[]
}

interface setMovementsAction {
  type: typeof SET_MOVEMENTS
  payload: IMovements
}

interface setExistencesActionOld {
  type: typeof SET_EXISTENCES
  payload: {
    id: string
  }
}

interface updateExistenceActionOld {
  type: typeof UPDATE_EXISTENCE
  payload: IRetirement
}

//Dealers
export const SET_DEALERS = 'SET_DEALERS'
export const SET_DEALER = 'SET_DEALER'
export const UPDATE_DEALER = 'UPDATE_DEALER'
export const DELETE_DEALER = 'DELETE_DEALER'
export const ENABLE_DEALER = 'ENABLE_DEALER'
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT'
export const ADD_DOCUMENT = 'ADD_DOCUMENT'

interface setDealersAction {
  type: typeof SET_DEALERS
  payload: IDealerResponse
}

interface setDealerAction {
  type: typeof SET_DEALER
  payload: IDealer
}

interface updateDealerAction {
  type: typeof UPDATE_DEALER
  payload: IDealer
}

interface deleteDealerAction {
  type: typeof DELETE_DEALER
  payload: IDealer
}

interface enableDealer {
  type: typeof ENABLE_DEALER
  payload: {
    id: string
    enable: boolean
  }
}

interface deleteDocument {
  type: typeof DELETE_DOCUMENT
  payload: {
    documentId: string
    providerId: string
  }
}

interface addDocument {
  type: typeof ADD_DOCUMENT
  payload: {
    providerId
    document
  }
}

//Clients
export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_CLIENT = 'SET_CLIENT'
export const UPDATE_CLIENT = 'UPDATE_CLIENT'
export const DELETE_CLIENT = 'DELETE_CLIENT'
export const ENABLE_CLIENT = 'ENABLE_CLIENT'
export const UPDATE_CREDIT = 'UPDATE_CREDIT'
export const DELETE_DOCUMENT_CLIENT = 'DELETE_DOCUMENT_CLIENT'
export const ADD_DOCUMENT_CLIENT = 'ADD_DOCUMENT_CLIENT'


//Sellers
export const GET_CLIENTS_BY_SELLERS = 'GET_CLIENTS_BY_SELLERS'
export const ENABLE_SELLER = 'ENABLE_SELLER'
export const GET_DELIVERY_NOTES_BY_CLIENT = 'GET_DELIVERY_NOTES_BY_CLIENT'

interface setClientsAction {
  type: typeof SET_CLIENTS
  payload: IClientResponse
}

interface setClientAction {
  type: typeof SET_CLIENT
  payload: IClient
}

interface updateClientAction {
  type: typeof UPDATE_CLIENT
  payload: IClient
}

interface deleteClientAction {
  type: typeof DELETE_CLIENT
  payload: IClient
}

interface enableClient {
  type: typeof ENABLE_CLIENT
  payload: {
    id: string
    enable: boolean
  }
}

interface updateCredit {
  type: typeof UPDATE_CREDIT
  payload: {
    id: string
    credit: any
  }
}

interface deleteDocumentClientType {
  type: typeof DELETE_DOCUMENT_CLIENT,
  payload: {
    id: string,
    clientId: string
  }
}

interface addDocumentClient {
  type: typeof ADD_DOCUMENT_CLIENT,
  payload: {
    clientId: number
    document: { id: string; url: string }
  }
}

//Transactions
export const ADD_TRANSFER = 'ADD_TRANSFER'
export const SET_TRANSFERS = 'SET_TRANSFERS'

interface addTransferAction {
  type: typeof ADD_TRANSFER
  payload: ITransferOld
}

interface setTransferssAction {
  type: typeof SET_TRANSFERS
  payload: ITransferOld[]
}

//Banks
export const SET_BANKS = 'SET_BANKS'

interface setBanksAction {
  type: typeof SET_BANKS
  payload: IBank[]
}

//Currencies
export const SET_CURRENCIES = 'SET_CURRENCIES'

interface setCurrenciesAction {
  type: typeof SET_CURRENCIES
  payload: ICurrency[]
}

//PaymentMethods
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS'

interface setPaymentMethodsAction {
  type: typeof SET_PAYMENT_METHODS
  payload: IPaymentMethod[]
}

//Bank Accounts Old
export const SET_BANK_ACCOUNTSOLD = 'SET_BANK_ACCOUNTS'
export const SET_BANK_ACCOUNTOLD = 'SET_BANK_ACCOUNT'
export const UPDATE_BANK_ACCOUNTOLD = 'UPDATE_BANK_ACCOUNT'
export const DELETE_BANK_ACCOUNTOLD = 'DELETE_BANK_ACCOUNT'

//Rates
export const SET_RATES = 'SET_RATES';

interface setBankAccountsActionOld {
  type: typeof SET_BANK_ACCOUNTSOLD
  payload: IBankAccountOld[]
}

interface setBankAccountActionOld {
  type: typeof SET_BANK_ACCOUNTOLD
  payload: IBankAccountOld
}

interface updateBankAccountActionOld {
  type: typeof UPDATE_BANK_ACCOUNTOLD
  payload: IBankAccountOld
}

interface deleteBankAccountActionOld {
  type: typeof DELETE_BANK_ACCOUNTOLD
  payload: IBankAccountOld
}

interface setRates {
  type: typeof SET_RATES,
  payload: any[]
}

//Accounts
export const SET_ACCOUNTS = 'SET_ACCOUNTS'
export const ADD_ACCOUNT = 'ADD_ACCOUNT'
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT'
export const SET_ACCOUNT_VISIBLE = 'SET_ACCOUNT_VISIBLE'
export const UPDATE_ACCOUNT_BALANCE = 'UPDATE_ACCOUNT_BALANCE'
export const SET_MOVEMENT_ACCOUNT = 'SET_MOVEMENT_ACCOUNT'
export const CLEAN_TRANSACTIONS = 'CLEAN_TRANSACTIONS'

interface setAccountsAction {
  type: typeof SET_ACCOUNTS
  payload: IMoneyAccount[]
}

interface addAccountAction {
  type: typeof ADD_ACCOUNT
  payload: IMoneyAccount
}

interface updateAccountAction {
  type: typeof UPDATE_ACCOUNT
  payload: IMoneyAccount
}

interface deleteAccountAction {
  type: typeof DELETE_ACCOUNT
  payload: string
}

interface setAccountVisible {
  type: typeof SET_ACCOUNT_VISIBLE
  payload: {
    id: string
    visible: boolean
  }
}

interface setUpdateBalance {
  type: typeof UPDATE_ACCOUNT_BALANCE
  payload: {
    id: string
    amount: string
  }
}

interface setMovement {
  type: typeof SET_MOVEMENT_ACCOUNT
  payload: { transactions: ITransactions[]; numberOfPages: number }
}

interface cleanTrans {
  type: typeof CLEAN_TRANSACTIONS
}

export type AuthTypes = authUserLoginAction | authUserLogOut |authUserSignUp | authUserFirstSignUp | authUserSecondSignUp | authUserThirdSignUp | authUserFourthSignUp | changeFirstTime

export type ClientTypes =
  | setClientAction
  | setClientsAction
  | updateClientAction
  | deleteClientAction
  | enableClient
  | updateCredit
  | deleteDocumentClientType
  | addDocumentClient

export type CategoriesTypes =
  | setCategoriesAction
  | createCategoryAction
  | updateCategoryAction
  | deleteCategoryAction

export type SubcategoriesTypes =
  | createSubcategoryAction
  | updateSubcategoryAction
  | deleteSubcategoryAction

export type ItemsTypes =
  | setItemAction
  | setItemsAction
  | updateItemAction
  | deleteItem
  | editCatalogStatus

export type ItemsListTypes = setItemList

export type AssociatedCodeTypes = setAssociatedCode | deleteAssociatedCode

export type CompoundTypes = setCompound | deleteCompound | editCompound

export type AssemblyTypes = deleteAssembly | setAssembly | editAssembly

export type UnitTypes = getUnits
export type CostAndPriceTypes = addCostAndPrice

export type RotationTypes = updateRotation

export type LocationsTypes =
  | setLocationAction
  | setLocationsAction
  | updateLocationAction
  | deleteLocationAction

export type WarehousesTypes =
  | setWarehouseAction
  | setWarehousesAction
  | updateWarehouseAction
  | deleteWarehouseAction
  | updateWarehouseExistence

export type ExistencesTypesOld =
  | setExistenceActionOld
  | setExistencesActionOld
  | updateExistenceActionOld

export type ExistencesTypes = setExistenceAction | cleanItemsAction

export type SellsTypes = setSellsAction | cleanSellsAction | updateSells

export type SellerTypes =
  | setSellersAction
  | setClientsBySeller
  | enableSeller
  | setDeliveryNotesByClient

export type DeliveryNotesTypes = setDeliveryNotes | cleanDeliveryNotes

export type SalesDeliveryNotesTypes =
  | setSalePendingDeliveryNotes
  | setHistoricDeliveryNotes
  | deleteMultipleSaleDeliveryNotes

export type PurchasesTypes = setPurchases | cleanPurchases

export type PurchaseOrdersTypes = setPurchaseOrders | cleanPurchaseOrders

// export type SellsTypes = setSellsAction | cleanSellsAction

export type PendingSellsTypes =
  | setPendingSellsAction
  | cleanPendingSellsAction
  | deleteMultipleSells

export type MovementTypes = setMovementsAction

export type DealerTypes =
  | setDealerAction
  | setDealersAction
  | updateDealerAction
  | deleteDealerAction
  | enableDealer
  | deleteDocument
  | addDocument

export type TransactionTypes = addTransferAction | setTransferssAction

export type BanksTypes = setBanksAction

export type CurrenciesTypes = setCurrenciesAction

export type PaymentMethodsTypes = setPaymentMethodsAction

export type AccountTypes =
  | setAccountsAction
  | addAccountAction
  | updateAccountAction
  | deleteAccountAction
  | setAccountVisible
  | setUpdateBalance
  | setMovement
  | cleanTrans

export type BankAccountsTypesOld =
  | setBankAccountsActionOld
  | setBankAccountActionOld
  | updateBankAccountActionOld
  | deleteBankAccountActionOld

export type RatesTypes = setRates